import { Button } from '@components/button';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { IconTrash } from '@components/icons/trash';
import { hideModal, Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useDeleteUser } from 'api/users/hooks';
import { User } from 'api/users/requests';

export const useRevokeTeamUserModal = () => useModal(RevokeInviteTeamUser);

export const RevokeInviteTeamUser = ({ user }: { user: User }) => {
  const { t } = useScopedTranslate(locale);

  const onSuccess = () => {
    hideModal();
  };

  const deleteMutation = useDeleteUser({
    id: user.id,
    onSuccess,
    toasterSuccessMessage: t('memberRevoked'),
  });

  return (
    <Modal>
      <Modal.SimpleHeader icon={<IconFormIndicatorWarning />} title={t('revokeMember')} />
      <Modal.Content>
        <Stack space={6}>
          <Stack>
            <Text text={t('areYouSure', { email: user.email })} />
          </Stack>
          <Stack orientation="horizontal" space={4} justify="flex-end">
            <Button variant="secondary" onClick={hideModal} text={t('core.cancel')} />
            <Button
              onClick={() => deleteMutation.mutate()}
              disabled={deleteMutation.isLoading}
              variant="primary-red"
              iconLeft={<IconTrash />}
              text={t('revoke')}
            />
          </Stack>
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    revokeMember: 'Revoke member invite',
    memberRevoked: 'Member invite revoked',
    areYouSure: 'Are you sure you want to revoke invite for {email}?',
    revoke: 'Revoke',
  },
};
